import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Row, Col, Grid, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'qrcode.react';

import Preloader from "../../views/Preloader/Preloader";
import CheckData from '../../shared/CheckData';
import { CustomCard } from "../../components/Card/CustomCard";
import { consultaUser } from "../../funciones/PefilFunction";
import { consultaDataUser, Inscribir, consultaOferta, InfoUC, ConsultDiasDisp } from '../../funciones/InscripcionFunction';
import { SvgToPng } from "../../funciones/AdmisionFunction";
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

import InscripcionTable from './InscripcionTable';
import InscripcionTableElect from './InscripcionTableElect';
import SelectTable from './SelectTable';

import CustomModal from "../../components/Modal/CustomModal";
import ModalReports from '../../components/Reportes/ModalReports';
import PlanillaInscripcion from '../../components/Reportes/PlanillaInscripcion';


let statusUser = 0;
let unCr = 0;
let unBs = 0;
let unBs2 = 0;
let statusBtn = 0;
let statusInsc = 0;
let status = 0;
let cuotas = "";
let cuotaN = "";
let Estudiante = "";

class Inscripcion extends Component {
    state = {
        cr: 0,
        statusUser: 0,
        dataInscripcion: "",
        materias: [],
        notificacionClass: "custom-alert-info",
        notificacionIcon: "fa fa-circle-o-notch fa-spin",
        notificacionText: "Verificando Información, espera por favor",
        notificacionPeriodo: "",
        notificacionStyles: {
            fontSize:12, position:"absolute", top: 4
        },
        textMateria: "Cargando Materias",
        materiasSelect: [],
        seccionesSelect: [],
        boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: false},
        seccionesSelectFull: [],
        seccionesSelectFull2: [],
        SecSelect: [],
        openW: false,

        semestres: [],
        
        valorSemestres: { value: '', label: ' - Selecciona un Nivel - ' },
        citas: [],
        valorCita: { value: '', label: ' - Selecciona un Día - ' },
        mensajeTabla: "Selecciona primero un periodo",
        preloaderEl: "",
        electSelect: 0,
        electCurs: 0,
        electAp: 0,
        ValorUc: "",
        totalBs: 0,
        periodoAct: "",
        tipoInsc: "",
        costoInsc: "",
        InscripcionDatos: "",
        datosPersonales: "",
        qr: "",
        modalConfirmBtn1:{ icon: "fa fa-check", text: "Si", disabled: false },
        openConfirm: false,
    }

    constructor (props) {
        super (props);
        unCr = 0;
        
        /* consultaDataUser ((resp) => {
            statusBtn = resp[1]
            unCr= resp[2]
            statusInsc = resp[3]
            status = resp[4]
            this.setState(resp[0])
            if(resp[0].InscripcionDatos !== "") {
                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp[0].InscripcionDatos.token).substring(0,10)}`}/>
                )
    
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
    
                SvgToPng (dataUri, (qr) => {
                    this.setState({ qr: qr })
                })
            }
        }) */

        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        ConsultDiasDisp ((resp) => {
            this.setState({citas: resp})
        })
    }

    componentWillMount = () => {
        consultaDataUser ((resp) => {
            statusBtn = resp[1]
            unCr= resp[2]
            unBs= resp[5]
            unBs2= resp[8]
            statusInsc = resp[3]
            status = resp[4]
            cuotas = resp[6]
            cuotaN = resp[7]
            this.setState(resp[0])

            if(resp[0].InscripcionDatos !== "") {
                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp[0].InscripcionDatos.token).substring(0,10)}`}/>
                )
    
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
    
                SvgToPng (dataUri, (qr) => {
                    this.setState({ qr: qr })
                })
            }
        })

        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        ConsultDiasDisp ((resp) => {
            this.setState({citas: resp})
        })
    }

    valorCitas = (valorCita) => {
        this.setState({
            valorCita
        });
    }

    valorSemestres = (valorSemestres) => {
        /* unCr = 0; */
        this.setState({
            valorSemestres,
            mensajeTabla: <div><i className="fa fa-spinner fa-spin"></i> Cargando oferta académica</div>,
            preloaderEl: "fa fa-spinner fa-spin"
            /* seccionesSelectFull:[] */
        }, () => {
            consultaUser((estudiante) => {
                Estudiante = estudiante
                consultaOferta (estudiante, valorSemestres.value, (resp) => {
                    if(resp[0].length === 0){
                        this.setState({
                            mensajeTabla: "No hay materias disponibles",
                            materias: [],
                            electCurs: 0,
                            preloaderEl: "",
                        })
                    }else{
                        this.setState({
                            materias: resp[0],
                            electCurs: resp[1],
                            electAp: resp[2],
                            mensajeTabla: "",
                            preloaderEl: "",
                        })
                    }
                })
            })
        });
    }

    addMateria = (materia, seccion, uc, bs, observ) => {
        let DatosSeccion = [
            materia,
            seccion,
            uc,
            bs,
            this.state.valorSemestres,
            observ
        ]

        unCr += parseInt(uc);
        unBs2 += parseFloat(bs);
        let mat = this.state.materiasSelect;
        let sec = this.state.seccionesSelect;
        let secFull = this.state.seccionesSelectFull;
        mat.push(materia)
        sec.push(seccion)
        /* secFull.push(seccion) */
        secFull.push(DatosSeccion)
        this.setState({
            materiasSelect: mat,
            seccionesSelect: sec,
            seccionesSelectFull: secFull
        })
    }

    delMateria = (materia, seccion, uc, bs) => {
        unCr -= uc;
        unBs -= parseFloat(bs);
        unBs2 -= parseFloat(bs);
        let mat = this.state.materiasSelect;
        let sec = this.state.seccionesSelect;
        let secFull = this.state.seccionesSelectFull;
        for (let i in mat) {
            if (mat[i] === materia) mat.splice(i, 1);
        }
        for (let i in sec) {
            if (sec[i] === seccion) sec.splice(i, 1);
        }

        
        for (let i in secFull) {
            /* if (secFull[i].id === seccion.id) secFull.splice(i, 1); */
            if (secFull[i][1].id === seccion.id) {
                secFull.splice(i, 1);
            }
        }

        this.setState({
            /* materiasSelect: mat,
            seccionesSelect: sec, */
            seccionesSelectFull: secFull
        })
        
    }

    respuestaInscribir = (resp) => {
        this.setState({
            boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: true},
            modalConfirmBtn1:{ icon: "fa fa-check", text: "Si", disabled: false },
            openConfirm: false
        }, () => {
            toast[resp.Type](resp.Text,{autoClose: 4000});
            if (resp.errores === 0) {
                consultaDataUser ((resp) => {
                    statusBtn = resp[1]
                    unCr= resp[2]
                    unBs= resp[5]
                    unBs2= resp[8]
                    cuotas = resp[6]
                    cuotaN = resp[7]
                    statusInsc = resp[3]
                    this.setState(resp[0])

                    if(resp[0].InscripcionDatos !== "") {
                        let imgSvg = (
                            <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${(resp[0].InscripcionDatos.token).substring(0,10)}`}/>
                        )
            
                        const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                        const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
            
                        SvgToPng (dataUri, (qr) => {
                            this.setState({ qr: qr })
                        })
                    }
                })
            }else{
                this.setState({
                    boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: false}
                }) 
            }
        })
    }

    openModal = () => {
        this.setState({
            openW:true
        })
    }

    modal = () => {
        if (this.state.openW === false) return null

        const { seccionesSelectFull, InscripcionDatos, tipoInsc, periodoAct, datosPersonales, costoInsc, qr } = this.state;
        return (
            <ModalReports 
                reporte={<PlanillaInscripcion
                    data = {seccionesSelectFull}
                    dataInscripcion = {InscripcionDatos}
                    tipoInsc = {tipoInsc}
                    periodo = {periodoAct}
                    dataEst = {datosPersonales}
                    cuotas = {cuotas}
                    cuotaN = {cuotaN}
                    creditos = {unCr}
                    monto = {unBs}
                    inscripcion = {costoInsc}
                    qr = {qr}
                />}
                titulo="Impresión de Planilla de Inscripción"
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
                />
        )
    }

    modalConfirm = () => {
        let {openConfirm, modalConfirmBtn1} = this.state;
        let { seccionesSelect, seccionesSelectFull, valorSemestres, valorCita } = this.state;
        const campos = { seccionesSelect, seccionesSelectFull, valorSemestres, valorCita }

        let contenido = () => (
            <div>
                <div>Vas a proceder a <strong className="text-danger">INSCRIBIRTE</strong>, este proceso <strong className="text-danger">SOLO PUEDES HACERLO UNA VEZ</strong> y no puede deshacerse. Presiona <strong>SI</strong> solamente si estas seguro de que has agregado <strong>TODAS</strong> las materias.</div>
                <div>¿Deseas confirmar tu inscripción?</div>
            </div>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalConfirmBtn1.icon}></i> {modalConfirmBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openConfirm}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {() => {
                    if (modalConfirmBtn1.disabled === true) return null

                    this.setState({
                        boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando", disabled: true },
                        modalConfirmBtn1:{ icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true }
                    },() => {
                        Inscribir (campos, unCr, (resp) => { this.respuestaInscribir(resp) })
                    })
                }}
                funcion2 = {() => {
                    if (modalConfirmBtn1.disabled === true) return null
                    this.setState({openConfirm: false})
                }}/>
        );
    }

    botones = () => {
        let { boton1 } = this.state;
        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                        this.setState({openConfirm: true})
                    }}><i className={boton1.Icon}></i> {boton1.Title}</button>
                )
            case 1:
                let contenido = (
                    <Popover bsSize="large" title="Pago Pendiente" id="Inscrito">
                        <div className="custom-alert-danger">Ya has hecho este proceso.</div>
                        <div align="justify" className="custom-mt-10">
                            Debes formalizar tu inscripción llevando la planilla de inscripción en la fecha pautada.
                        </div>
                        <div align="justify" className="custom-mt-10">
                            Para cancelar los aranceles de la inscripción puedes realizar la transferencia e ingresar los datos en el módulo de Estado de Cuenta.
                        </div>
                        <div align="justify" className="custom-mt-10">
                            También puedes ir a <strong>Académicos / Retiro de Materias</strong> si deseas retirar alguna materia.
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <button style={{borderWidth: 1}} onClick={this.openModal} title="Imprimir planilla de Inscripción" className="btn btn-info"><i className="fa fa-print"></i>Imprimir Planilla</button>
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                        </OverlayTrigger>
                    </div>
                )
            case 3:
                return null
            case 4:
                let contenido2 = (
                    <Popover bsSize="large" title="Importante" id="Inscrito">
                        <div className="custom-alert-primary" style={{fontSize:11}} align="center">¿Por qué no puedo realizar este proceso?</div>
                        <div align="justify" className="custom-mt-10">
                            Este proceso solo puedes llevarlo a cabo si no posees una solicitud de cambio de carrera abierta.
                        </div>
                        <div align="justify" className="custom-mt-10">
                            Debes esperar que te llegue a tu email una notificación con la respuesta de dicha solicitud primero para poder realizar el proceso de inscripción
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 5:
                let contenido3 = (
                    <Popover bsSize="large" title="Pendiente por Aprobación" id="Inscrito">
                        <div className="custom-alert-danger">Ya has hecho este proceso.</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente debes esperar la aprobación de Control de Estudios
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido3}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 6:
                let contenido6 = (
                    <Popover bsSize="large" title="No puedes realizar esta acción" id="Inscrito6">
                        <div className="custom-alert-danger">No Tienes Estado de Cuenta.</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente debes esperar que se Aperture tu Cuenta para poder realizar este proceso. Ponte en contacto con Administración
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido6}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 7:
                let contenido7 = (
                    <Popover bsSize="large" title="No puedes realizar esta acción" id="Inscrito7">
                        <div className="custom-alert-danger">No realizar este proceso.</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente tienes una deuda pendiente. Ingresa a <strong>Estado de Cuenta</strong> para revisar.
                        </div>
                    </Popover>
                )

                return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido7}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            case 8:
                let contenido8 = (
                    <Popover bsSize="large" id="Inscrito7">
                        <div className="custom-alert-danger">No realizar este proceso.</div>
                        <div align="justify" className="custom-mt-10">
                            Actualmente tienes una deuda pendiente pero puedes imprimir la <strong className="text-danger">Planilla de Inscripción</strong>. Ingresa a <strong>Estado de Cuenta</strong> para revisar.
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <button style={{borderWidth: 1}} onClick={this.openModal} title="Imprimir planilla de Inscripción" className="btn btn-info"><i className="fa fa-print"></i>Imprimir Planilla</button>
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido8}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={boton1.Icon}></i> {boton1.Title}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-times" title="Presiona F5 para refrescar esta página"></i> Error al Cargar</button>
                )
        }
    }

    inscripcion = () => {
        let { dataInscripcion, materias, materiasSelect, seccionesSelectFull, valorSemestres, semestres, mensajeTabla, electSelect,
            electCurs, electAp, preloaderEl, ValorUc, saldo, valorCita, citas, notificacionPeriodo, periodoAct, tipoInsc, costoInsc } = this.state;


        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let contenidoMaterias = () => {
            if(materias.length === 0)return (
                <tr>
                    <td colSpan={8} align= "center" style={{padding: 5, fontSize: 12}}>
                        {mensajeTabla}
                    </td>
                </tr>
            )

            let contenido = [];
            let sec = 0;
            for (let i in materias) {
                if (materias[i].tipo_mat === "TEORICA"){
                    contenido.push(
                        <InscripcionTable key={ materias[i].seccionId } opciones={materias[i]} materiasS={materiasSelect} 
                            sec = {sec}    
                            add = {(materia, seccion, uc, bs, observ) => {this.addMateria(materia, seccion, uc, bs, observ)}}
                            del = {(materia, seccion, uc, bs, observ) => {this.delMateria(materia, seccion, uc, bs, observ)}}
                            Estudiante = {Estudiante}/>
                    )
                    sec+=2000
                }
            }

            return contenido;
            
        }

        let updElectivas = (valor) => {
            this.setState({
                electSelect: (this.state.electSelect + valor)
            })
        }

        let contenidoMatElectvas = () => {
            let contenido = [];
            let elect = 0
            for (let i in materias) {
                if (materias[i].tipo_mat === "ELECTIVA"){
                    contenido.push(
                        <InscripcionTableElect key={ materias[i].seccionId } opciones={materias[i]} materiasS={materiasSelect} 
                        add = {(materia, seccion, uc, bs) => {this.addMateria(materia, seccion, uc, bs)}}
                        del = {(materia, seccion, uc, bs) => {this.delMateria(materia, seccion, uc, bs)}}
                        funcion1 = {(valor) => {updElectivas(valor)}}
                        cantSelect = {electSelect}
                        electAp = {electAp}
                        Estudiante = {Estudiante}/>
                    );
                    elect ++;
                } 
            }

            if (elect > 0) {

                return (
                    <React.Fragment>
                        <div className="text-danger custom-mt-10">Materias Electivas Disponibles:</div>
                        <div className="custom-mt-10" style={{marginTop: -2, fontSize: 10}}>Seleccionadas ({electSelect}) | Cursadas ({electCurs}) | Aprobadas ({electAp})</div>
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="55%" style={styles}><strong>Materia</strong></td>
                                        <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>Cupos</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>U.C.</strong></td>
                                        <td width="25%" align="center" style={styles}><strong>Acciones</strong></td>
                                        <td width="40px" align="center" style={styles}><strong>Info</strong></td>
                                        <td width="5%" align="center" style={styles}></td>
                                    </tr>
                                    {contenido}
                                </tbody>
                            </Table>
                        </div>
                    </React.Fragment>
                )
            }
        }

        let materiaSeleccionadas = () => {
            let { seccionesSelectFull } = this.state;
            if(seccionesSelectFull.length === 0) return (
                <tr>
                    <td colSpan={6} align= "center" style={{padding: 5, fontSize: 12}}>
                    Ninguna Seleccionada
                    </td>
                </tr>
            )
            
            return (
                seccionesSelectFull.map(option => (
                    <SelectTable key={ option.id + Math.floor(Math.random()*(10000 + 1)) } id= { option } />
                ))
            )
        }

        let textadmision = () => {
            let periodoAc = `Tu admisión es válida ${periodoAct}`;
            let periodoAdm = notificacionPeriodo;
            if (notificacionPeriodo === "") return null;

            if (periodoAc === periodoAdm) return (
                <div className="custom-alert-success" style={{padding: 5, marginBottom: 10}}>Tu admisión es válida para este periodo</div>
            )

            return (
                <div className="custom-alert-danger" style={{padding: 5, marginBottom: 10}}>{notificacionPeriodo}</div>
            )
        }

        let seleccionaMaterias = () => {
            if (statusInsc === 0) {
                return (
                    <React.Fragment>
                        <div className="custom-alert-info" style={{padding:10}}>
                            <Row>
                                <Col md={7}>
                                    <div style={{fontSize:12}}>Completa los campos para formalizar tu inscripción para la carrera <strong>{dataInscripcion}</strong></div>
                                </Col>
                                <Col md={5}>
                                    <Select
                                        isSearchable ={true}
                                        value={valorSemestres}
                                        onChange={this.valorSemestres}
                                        options={semestres}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="text-danger custom-mt-10">Materias Disponibles: <i className={preloaderEl}></i></div>    
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="55%" style={styles}><strong>Materia</strong></td>
                                        <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>Cupos</strong></td>
                                        <td width="15px" align="center" style={styles}><strong>U.C. Horas</strong></td>
                                        <td width="25%" align="center" style={styles}><strong>Modalidad</strong></td>
                                        <td width="40px" align="center" style={styles}><strong>Info</strong></td>
                                        <td width="5%" align="center" style={styles}></td>
                                    </tr>
                                    {contenidoMaterias()}
                                </tbody>
                            </Table>
                        </div>

                        {contenidoMatElectvas()}
                    </React.Fragment>
                )
            }else if (statusInsc === 4) {
                return(
                    <React.Fragment>
                        <div className="custom-alert-info" style={{padding:10}}>
                                <Row>
                                    <Col md={7}>
                                        <div style={{fontSize:12}}>No puedes realizar este proceso</div>
                                    </Col>
                                </Row>
                            </div>
                    </React.Fragment>
                )
            }else if (statusInsc === 6) {
                return(
                    <React.Fragment>
                        <div className="custom-alert-info" style={{padding:10}}>
                                <Row>
                                    <Col md={7}>
                                        <div style={{fontSize:12}}>No puedes realizar este preoceso</div>
                                    </Col>
                                </Row>
                            </div>
                    </React.Fragment>
                )
            }else{
                return(
                    <React.Fragment>
                        <div className="custom-alert-info" style={{padding:10}}>
                                <Row>
                                    <Col md={7}>
                                        <div style={{fontSize:12}}>Ya realizaste este proceso</div>
                                    </Col>
                                </Row>
                            </div>
                    </React.Fragment>
                )
            }
        }

        return(
            <React.Fragment>
                <Row className="text-danger">
                    <Col md={5}>
                        {/* <h5 style={{paddingTop: 0}}>Saldo Disponible: <span className="badge badge-red">{saldo} Bs.</span></h5> */}
                    </Col>
                    <Col md={12} align="right">
                        <h5 style={{paddingTop: 0}}>Valor actual de la Unidad de Crédito: <span className="badge badge-red">{formatNumber(ValorUc)} Bs.{/*  |  {formatReconver(ValorUc)} Bs. */}</span></h5>
                    </Col>
                </Row>
                {textadmision()}
                {seleccionaMaterias()}
                <div className="text-danger custom-mt-10">Materias Seleccionadas ({seccionesSelectFull.length}):</div>
                <div className="table-responsive">
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="40%" style={styles}><strong>Materia</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Sección</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Modalidad</strong></td>
                                <td width="15%" align="center" style={styles}><strong>Nivel</strong></td>
                                <td width="5%" align="center" style={styles}><strong>U.C. Horas</strong></td>
                                <td width="20%" align="right" style={stylesBs}><strong>Monto</strong></td>
                            </tr>
                            {materiaSeleccionadas()}
                            <tr className="custon-back-color">
                                <td align="right" colSpan={4} style={styles} ><strong>Total U.C. | Horas</strong></td>
                                <td align="center" style={styles}>{ unCr }</td>
                                <td align="right" style={styles}>
                                    {formatNumber(unBs2)} Bs.
                                    {/* <div>{formatReconver(unBs2)} Bs.</div> */}
                                </td>
                            </tr>
                            <tr className="custon-back-color">
                                <td align="right" colSpan={4} style={styles} >Tipo: <strong>{tipoInsc}</strong></td>
                                <td colSpan={2} align="right" style={styles}>
                                    {formatNumber(parseFloat(costoInsc))} Bs.
                                    {/* <div>{formatReconver(parseInt(costoInsc))} Bs.</div> */}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div className="custom-alert-danger custom-mt-10" align= "right" style = {{fontSize: 16}}>Total <strong>{formatNumber(parseFloat(unBs2) + parseFloat(costoInsc))} Bs.{/*  |  {formatReconver(parseInt(unBs2) + parseInt(costoInsc))} Bs */}</strong></div>
                <div className="custom-alert-info custom-mt-10" align= "right" style={{fontSize: 13, padding: 5}}>
                    <div style = {{fontSize: 11, color:"000"}} align= "left">
                        <strong>IMPORTANTE: El Total en Bs. de las materias corresponde al valor actual de la Unidad de Crédito por lo que puede variar en cada cuota. El monto es solo referencial. Si deseas saber el monto a pagar ve a <span className="text-danger">ESTADO DE CUENTA</span></strong>
                    </div>
                </div>
                <Row className="custom-mt-10">
                    <Col md={5} title ="Selecciona el día para asistir a tu inscripción">
                        <Select
                            isSearchable ={true}
                            value={valorCita}
                            onChange={this.valorCitas}
                            options={citas}
                        />
                        <div className="text-muted" style={{fontSize: 10}}>Selecciona el día de inscripción</div>
                    </Col>
                    <Col md={7} align="right">
                        {this.botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    change = () => {

    }

    ayuda = () => {
        return(
            <React.Fragment>
                <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Selecciona <strong>El Nivel</strong> donde se encuentra la(s) materia(s) a inscribir</div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Al ingresar a este módulo verás las materias que tienes disponible para inscribir.</div>
                    <div>Selecciona la(s) materia(s) de la sección de tu preferencia haciendo click en el boton <Switch
                    height={12} onChange={this.change} width={24} checked={false} /> que cambiara su estado a <Switch
                    height={12} onChange={this.change} width={24} checked={true} /> indicandote que la has seleccionado
                    </div>
                    <div>
                        El botón <button style={{borderWidth: 1}} className="btn btn-relleno-primary btn-xs">
                        <i className="fa fa-question-circle-o"></i></button> te mostrará mas información de la sección
                    </div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                </Col>
                <Col md={12} align="justify">
                    Selecciona el tipo de modalidad para la materia. (Presencial, Verano o Prueba de Suficiencia)
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 4:</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez seleccionada la(s) materia(s) verifica que son las que deseas y presiona el botón <button 
                    style={{borderWidth: 1}} className="btn btn-primary btn-xs">
                    <i className="fa fa-check"></i> Continuar</button> para culminar el proceso
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 5:</strong>
                </Col>
                <Col md={12} align="justify">
                    Imprime la planilla de inscripción.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 6:</strong>
                </Col>
                <Col md={12} align="justify">
                    <strong className="text-danger">Pago de Aranceles</strong>
                    <div>
                        El pago de aranceles de la inscripción puedes hacerlo mediante transferencia bancaria y luego ingresa los datos de la transferencia en el módulo de <strong>Estado de Cuenta</strong> y espera que el pago sea verificado.
                    </div>
                    <div>
                        También puedes dirigirte a la institución y pagar directamente en Caja
                    </div>
                    <div>
                        <strong>El valor de la Unidad de Crédito puede cambiar</strong>
                    </div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong>IMPORTANTE:</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez realizada la inscripción no podrás modificar las materias selecionadas en este módulo.
                </Col>
                </Row>
            </React.Fragment>
        )
    }

    contenidOk = () => {
        let { notificacionClass, notificacionText, notificacionIcon, notificacionStyles, periodoAct } = this.state;
        return(
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={8}>
                                <div className={notificacionClass} style={{padding:10}}>
                                    <Row>
                                        <Col md={11}><div style={{fontSize:16}}>{notificacionText}</div></Col>
                                        <Col md={1}><i className={notificacionIcon} style={notificacionStyles}></i></Col>
                                    </Row>
                                </div>
                                <div className="custom-mt-10">
                                    <CustomCard
                                        /* title={`Inscripción para el periodo ${periodoAct}`} */
                                        title={`Inscripción`}
                                        category=""
                                        color="#a80012"
                                        content={this.inscripcion()}
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Inscripción</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
                {this.modal()}
                {this.modalConfirm()}
            </React.Fragment>
        )
    }
    render() {
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/perfil" />)
            case 2:
                return (<Redirect to="/perfil" />)
            case 3:
                return (this.contenidOk())
            case 4:
                return (<Redirect to="/perfil" />)
            case 5:
                switch (status) {
                    case "1":
                        return (this.contenidOk())
                    case 0:
                        return (<Preloader/>)
                    case "":
                        return (this.contenidOk())
                    case "2":
                        return (this.contenidOk())
                    default:
                        return (this.contenidOk())
                }
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default Inscripcion;


// WEBPACK FOOTER //
// ./src/views/Inscripcion/Inscripcion.jsx